import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="reveal lg:col-span-4">
            <span className="font-label text-[11px] tracking-[0.3em] text-foreground-500">
              FAQ
            </span>
            <h2 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-[40px]">
              关于访问
              <br />
              你可能会问
            </h2>
            <p className="mt-5 text-sm leading-8 text-foreground-600">
              下面整理了关于备用地址、镜像站与永久地址最常被问到的问题。若仍未解决，可先切换线路再回到本页确认状态。
            </p>
          </div>

          <div className="reveal lg:col-span-8">
            <div className="divide-y divide-background-300 border-y border-background-300">
              {faqs.map((item) => {
                const isOpen = openId === item.id;
                return (
                  <div key={item.id}>
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : item.id)}
                      className="flex w-full cursor-pointer items-center justify-between gap-6 py-6 text-left"
                    >
                      <span className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                        {item.q}
                      </span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors ${
                          isOpen
                            ? "border-primary-500 bg-primary-500 text-background-50"
                            : "border-background-400 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                      </span>
                    </button>
                    {isOpen && (
                      <p className="max-w-3xl pb-7 pr-10 text-sm leading-8 text-foreground-700">
                        {item.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}